import { Col } from 'antd';
import { SectionTitle } from 'components/Section';
import WhitePaperCard from 'components/WhitePaperCard';

type Props = {
    whitePaper: WhitePaper;
};

export const WhitePaperBlock = ({ whitePaper }: Props) => {
    return (
        <>
            <SectionTitle title="White Paper" url={`/white-papers`} />
            <Col span={24}>
                <WhitePaperCard item={whitePaper} />
            </Col>
        </>
    );
};

export default WhitePaperBlock;
